<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Dashboard'"
      [class]="extraClass"
      [canGoBack]="false" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="!windowService.isDesktopRes">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Dashboard'" />
          <form [formGroup]="form" novalidate action="#">
            <tidy-search-input
              formControlName="search"
              [placeholder]="'Search'"
              [icon]="'assets/img/search-header.svg'"
              class="header-search" />
          </form>
          <tidy-small-button
            [text]="'Add Credit'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="goToAddCredit()" />
          <tidy-small-button
            [text]="'Add Employee'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="addEmployee()" />
          <tidy-image
            [src]="'assets/img/download_csv.svg'"
            class="desktop-header-icon secondary-text-icon"
            (action)="exportCSV()" />
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
          }
        </div>
      </tidy-desktop-header>
    }

    @if (!windowService.isDesktopRes) {
      <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
        <tidy-text
          [header]="('Company Credit: ' | translate) + (companyCredit | tcurrency)" />
        <tidy-text
          [body]="'Add Credit'"
          class="link padding-left"
          (action)="goToAddCredit()" />
      </tidy-row>
      <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
        <tidy-text
          [header]="'Employees'" />
        <tidy-text
          class="link"
          (action)="addEmployee()"
          [body]="'Add Employee'" />
      </tidy-row>
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    }

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded) {
      @if (windowService.isDesktopRes) {
        <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
          <tidy-text
            [header]="('Company Credit: ' | translate) + (companyCredit | tcurrency)" />
          <tidy-text
            [body]="'Add Credit'"
            class="link padding-left"
            (action)="goToAddCredit()" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
          <tidy-text
            [header]="'Employees'" />
          <tidy-text
            class="link"
            (action)="addEmployee()"
            [body]="'Add Employee'" />
        </tidy-row>
      }
      <tidy-row>
        <tidy-table
          #tidyTable
          [dataSource]="shownRows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          [skipEntrance]="true"
          (sortChange)="sortChanged($event)"
          (cellClick)="goToEditEmployee($event)" />
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
